import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    //登录
    {
      path: '/',
      component: resolve => require(['@/components/login'], resolve)
    },
    {
      path: '/weixin/auth',
      component: resolve => require(['@/components/weixin/auth'], resolve)
    },
    {
      path: '/weixin/',
      component: resolve => require(['@/components/weixin/index'], resolve),
      children: [{
          meta: {
            title: '会员中心'
          },
          path: '/weixin/member',
          component: resolve => require(['@/components/weixin/member'], resolve)
        },
        {
          meta: {
            title: '用户注册'
          },
          path: '/weixin/register',
          component: resolve => require(['@/components/weixin/register'], resolve)
        },
        {
          meta: {
            title: '会员缴费'
          },
          path: '/weixin/member_pay',
          component: resolve => require(['@/components/weixin/member_pay'], resolve)
        },
        {
          meta: {
            title: '资料修改'
          },
          path: '/weixin/edit',
          component: resolve => require(['@/components/weixin/edit'], resolve)
        },
        {
          meta: {
            title: '考试报名'
          },
          path: '/weixin/exam/apply',
          component: resolve => require(['@/components/weixin/exam/apply'], resolve)
        },
        {
          meta: {
            title: '报名考试'
          },
          path: '/weixin/exam/hall',
          component: resolve => require(['@/components/weixin/exam/hall'], resolve)
        },
        {
          meta: {
            title: '报名支付'
          },
          path: '/weixin/exam/pay',
          component: resolve => require(['@/components/weixin/exam/pay'], resolve)
        },
        {
          meta: {
            title: '考试查询'
          },
          path: '/weixin/exam/query',
          component: resolve => require(['@/components/weixin/exam/query'], resolve)
        },
        {
          meta: {
            title: '会员信息'
          },
          path: '/weixin/member_detail',
          component: resolve => require(['@/components/weixin/member_detail'], resolve)
        }
      ]
    },
    //主页面
    {
      path: '/manage/',
      component: resolve => require(['@/components/manage/index'], resolve),
      children: [
        {
          path: '/manage/',
          component: resolve => require(['@/components/manage/welcome'], resolve)
        },
        //会员管理页
        {
          path: '/manage/user/member',
          component: resolve => require(['@/components/manage/user/member'], resolve)
        },
        //用户管理页
        {
          path: '/manage/user/lists',
          component: resolve => require(['@/components/manage/user/lists'], resolve)
        },
        //用户管理页-审核修改信息页
        // {
        //   path: '/manage/user/userAction/userAction',
        //   component: resolve => require(['@/components/manage/user/userAction/userAction'], resolve)
        // },

        //考试管理目录下路由开始
        //考试管理-报名列表页
        {
          path: '/manage/exam/examUser',
          component: resolve => require(['@/components/manage/exam/examUser'], resolve)
        },
        //考试管理-报名列表页-修改资料页
        {
          path: '/manage/exam/edit/edit',
          component: resolve => require(['@/components/manage/exam/edit/edit'], resolve)
        },
        //考试管理-考试设置页
        {
          path: '/manage/exam/exam',
          component: resolve => require(['@/components/manage/exam/exam'], resolve)
        },
        //考试管理-考场设置页
        {
          path: '/manage/exam/examHall',
          component: resolve => require(['@/components/manage/exam/examHall'], resolve)
        },
        //考试管理-准考证页
        {
          path: '/manage/exam/ticket',
          component: resolve => require(['@/components/manage/exam/ticket'], resolve)
        },
        //考试管理-报名统计页
        {
          path: '/manage/exam/userstatistics',
          component: resolve => require(['@/components/manage/exam/userstatistics'], resolve)
        },
        //考试管理-操作证号分配页
        {
          path: '/manage/exam/numMent',
          component: resolve => require(['@/components/manage/exam/numMent'], resolve)
        },
        //考试管理目录下路由结束

        //系统设置-会费设置
        {
          path: '/manage/setting/setting',
          component: resolve => require(['@/components/manage/setting/setting'], resolve)
        },
        {
          path: '/manage/setting/entrySet',
          component: resolve => require(['@/components/manage/setting/entrySet'], resolve)
        },

        //缴费管理目录下路由开始
        //缴费管理-交费管理
        {
          path: '/manage/recorder/recorder',
          component: resolve => require(['@/components/manage/recorder/recorder'], resolve)
        },
        //缴费管理目录下路由结束
        {
          path: '/manage/admin/lists',
          component: resolve => require(['@/components/manage/admin/lists'], resolve)
        },
        {
          path: '/manage/admin/group',
          component: resolve => require(['@/components/manage/admin/group'], resolve)
        },
        {
          path: '/manage/admin/menu',
          component: resolve => require(['@/components/manage/admin/menu'], resolve)
        },
        // 考试设置
        {
          path: '/manage/exam/exam',
          component: resolve => require(['@/components/manage/exam/exam'], resolve)
        },
        // 考场设置
        {
          path: '/manage/exam/examHall',
          component: resolve => require(['@/components/manage/exam/examHall'], resolve)
        },
        // 报名列表
        {
          path: '/manage/exam/examUser',
          component: resolve => require(['@/components/manage/exam/examUser'], resolve)
        },
        // 操作证号分配
        {
          path: '/manage/exam/numMent',
          component: resolve => require(['@/components/manage/exam/numMent'], resolve)
        },
        // 准考证
        {
          path: '/manage/exam/ticket',
          component: resolve => require(['@/components/manage/exam/ticket'], resolve)
        },
        // 报名统计
        {
          path: '/manage/exam/userstatistics',
          component: resolve => require(['@/components/manage/exam/userstatistics'], resolve)
        },
        // 会员列表
        {
          path: '/manage/user/member',
          component: resolve => require(['@/components/manage/user/member'], resolve)
        },
        // 用户列表
        {
          path: '/manage/manage/user/lists',
          component: resolve => require(['@/components/manage/user/lists'], resolve)
        },
         // 用户审核
         {
          path: '/manage/user/check',
          component: resolve => require(['@/components/manage/user/check'], resolve)
        },
        // 会员审核
        {
          path: '/manage/user/memberform',
          component: resolve => require(['@/components/manage/user/memberform'], resolve)
        },
        // 交费管理
        {
          path: '/manage/recorder/recorder',
          component: resolve => require(['@/components/manage/recorder/recorder'], resolve)
        },
        // 会费设置
        {
          path: '/manage/setting/setting',
          component: resolve => require(['@/components/manage/setting/setting'], resolve)
        },
        //人员管理目录下路由开始
        //人员管理-人员管理
        {
          path: '/manage/adminGourp/admin',
          component: resolve => require(['@/components/manage/adminGourp/admin'], resolve)
        },
        //人员管理-菜单管理
        {
          path: '/manage/adminGourp/adminMenu',
          component: resolve => require(['@/components/manage/adminGourp/adminMenu'], resolve)
        },
        //人员管理-角色管理
        {
          path: '/manage/adminGourp/adminGroup',
          component: resolve => require(['@/components/manage/adminGourp/adminGroup'], resolve)
        },
        //人员管理-角色管理-权限设置
        {
          path: '/manage/adminGourp/groupadd/groupadd',
          component: resolve => require(['@/components/manage/adminGourp/groupadd/groupadd'], resolve)
        },
        //角色管理目录下路由结束

        //新闻管理路由
        //新闻咨询-新闻管理
        // {
        //   path: '/manage/article/article',
        //   component: resolve => require(['@/components/manage/article/article'], resolve)
        // },
        //新闻咨询-新闻分类
        // {
        //   path: '/manage/article/articleCate',
        //   component: resolve => require(['@/components/manage/article/articleCate'], resolve)
        // },
      ]
    },
    //考试管理-准考证页-准考证打印页
    {
      path: '/manage/exam/ticketdy/ticketdy',
      component: resolve => require(['@/components/manage/exam/ticketdy/ticketdy'], resolve)
    },
    //无线电后台部分路由配置结束
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js